import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { SeekingPositions } from '../../types/instance';

export const useOnSeekingFilmoscope = (onSeeking: (params: SeekingPositions) => void) => {
    useInstanceEffect((instance) => {
        if (instance.type === 'filmoscope') {
            instance.onSeeking(onSeeking);
        }
    });
};
